import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  IconButton,
  Grid2,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Grid,
} from "@mui/material";
import BedIcon from "@mui/icons-material/Bed";
import BathtubIcon from "@mui/icons-material/Bathtub";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { Carousel } from "react-responsive-carousel";
import { useNavigate } from "react-router-dom";
import { addToWishlist } from "../../services/wishlistService";
import { Dialogue } from "./Dialogue";
import SignInPage from "../sign-in";
import Toast from "../Toast";
import VerifiedIcon from '@mui/icons-material/Verified';
import ShareIcon from '@mui/icons-material/Share';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';

function Product(props) {
  const navigate = useNavigate();
  const [wishlisted, setWishlisted] = useState(false);
  const [perModal, setPermModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));

  const handleCardClick = () => {
    navigate(`/property/${props.property._id}`);
  };

  const handleWishlistToggle = async (e) => {
    if (!user) {
      setPermModal(true);
      return;
    }
    e.stopPropagation();
    try {
      const userId = user.id ? user.id : user._id
      const response = await addToWishlist(userId, props.property._id);
      if (response) {
        setWishlisted(!wishlisted);
        setSeverity('success')
        setToastMessage("Property added to wishlist!");
        setToastOpen(true);
      }
    } catch (error) {
      console.error("Error updating wishlist:", error);
      setSeverity('error');
      setToastMessage("Failed to add property to wishlist. Please try again.");
      setToastOpen(true);
    }
  };

  const formatCurrency = (amount) => {
    // Handle undefined, null, or NaN values
    if (!amount || isNaN(amount)) {
      return "₹ Contact for Price";
    }

    let local = props.property.country === 'United Kingdom' ? "en-GB" : "en-IN";
    let currency = props.property.country === 'United Kingdom' ? "GBP" : "INR";
    return new Intl.NumberFormat(local, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
    }).format(amount);
  };


  const handleShare = (e) => {
    e.stopPropagation();
    setOpenShareDialog(true);
  };

  const handleClose = () => {
    setOpenShareDialog(false);
  };

  const shareUrl = window.location.href;

  const handleWhatsAppShare = () => {
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`, '_blank');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank');
  };

  const handleEmailShare = () => {
    window.open(`mailto:?subject=Check out this property&body=${encodeURIComponent(shareUrl)}`);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setOpenSnackbar(true);
    handleClose();
  };

  return (
    <Grid2 size={{ md: props.gridMd }} sx={{ padding: '10px' }}>
      <Card sx={{ boxShadow: 3, borderRadius: 2, cursor: "pointer", display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ position: "relative", flexGrow: 1 }} onClick={handleCardClick}>
          <Carousel showThumbs={false} infiniteLoop showStatus={false} autoPlay>
            {props?.property?.images?.map((image, index) => (
              <img key={index} src={image} alt={`Property ${index + 1}`} height={"250px"} />
            ))}
          </Carousel>
          <Chip
            label={props?.property?.propertyStatus || props?.property?.listingType || 'For Sale'}
            sx={{
              position: "absolute",
              top: 16,
              left: 16,
              backgroundColor: (() => {
                const ps = (props?.property?.propertyStatus || '').toLowerCase();
                if (ps === 'rented' || ps === 'sold') return '#f44336';
                if (ps === 'for rent') return '#2196f3';
                return "#d8b035";
              })(),
              color: "#fff",
              fontWeight: "bold",
              paddingX: 1.5,
            }}
          />

          {props?.country === 'India' && <Chip
            icon={<VerifiedIcon sx={{ color: "#fff !important" }} />}
            label={'Verified'}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              backgroundColor: "green",
              color: "#ffff",
              fontWeight: "bold",
              paddingX: 1.5,
            }}
          />}
        </Box>
        <CardContent sx={{ flexGrow: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Chip
              label={props?.property?.propertyType || props?.property?.type}
              size="small"
              sx={{
                backgroundColor: "#f0f4ff",
                color: "#d8b035",
                fontWeight: "bold",
                marginBottom: 1,
              }}
            />
            <IconButton onClick={handleWishlistToggle}>
              {wishlisted ? (
                <FavoriteIcon sx={{ color: "#e91e63" }} />
              ) : (
                <FavoriteBorderIcon sx={{ color: "#757575" }} />
              )}
            </IconButton>
          </Box>
          <Box onClick={handleCardClick}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#d8b035" }}>
                {formatCurrency(props?.property?.price || props?.property?.rentOrPrice)}{" "}
                {(props?.property?.listingType || props?.property?.propertyStatus) === "For Rent" && "PCM"}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#d8b035" }}>
                <IconButton onClick={(e) => handleShare(e)} sx={{ color: "#d8b035" }} onMouseDown={(e) => e.stopPropagation()} >
                  <ShareIcon />
                </IconButton>
              </Typography>
            </div>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginTop: 0.5 }}>
              {props?.property?.title || props?.property?.name}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", marginTop: 1, color: "#666" }}>
              <LocationOnIcon fontSize="small" sx={{ color: "#d8b035" }} />
              <Typography variant="body2" sx={{ marginLeft: 0.5 }}>
                {props?.property?.address || props?.property?.location}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", color: "#666" }}>
                <CropSquareIcon fontSize="small" sx={{ color: "#d8b035" }} />
                <Typography variant="body2" sx={{ marginLeft: 0.5 }}>
                  {props?.property?.area || props?.property?.landSize} sqft
                </Typography>
              </Box>
              {(props?.property?.propertyType || props?.property?.type) !== "Office" && (
                <Box sx={{ display: "flex", alignItems: "center", color: "#666" }}>
                  <BedIcon fontSize="small" sx={{ color: "#d8b035" }} />
                  <Typography variant="body2" sx={{ marginLeft: 0.5 }}>
                    {props?.property?.bedrooms}
                  </Typography>
                </Box>
              )}
              <Box sx={{ display: "flex", alignItems: "center", color: "#666" }}>
                <BathtubIcon fontSize="small" sx={{ color: "#d8b035" }} />
                <Typography variant="body2" sx={{ marginLeft: 0.5 }}>
                  {props?.property?.bathroom} Bath
                </Typography>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
      <Dialog sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }} maxWidth="xs" open={perModal}>
        <DialogTitle>Warning !</DialogTitle>
        <DialogContent dividers>
          <Typography>
            If You want to add to wishlist, please click on Login.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" sx={{ color: "#0d1741" }} onClick={() => setPermModal(false)}>
            Cancel
          </Button>
          <Button
            color="secondary"
            sx={{
              backgroundColor: "#d8b035",
              color: "white",
              "&:hover": {
                backgroundColor: "#c5a02f",
              },
              "@media (max-width: 600px)": {
                fontSize: "1rem",
              },
            }}
            onClick={() => setOpenModal(true)}
          >
            Login
          </Button>
        </DialogActions>
      </Dialog>
      {openModal && (
        <Dialogue open={openModal} onClose={setOpenModal}>
          <SignInPage />
        </Dialogue>
      )}

      <Dialog
        open={openShareDialog}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          padding: '16px 24px',
          marginBottom: 2,
          fontWeight: 'bold',
        }}>
          Share Property
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box
                onClick={handleCopyLink}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: 1,
                  padding: '16px 24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  cursor: 'pointer',
                  height: '100%',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                    borderColor: '#d8b035'
                  }
                }}
              >
                <ContentCopyIcon sx={{ color: '#666', fontSize: 28, marginRight: 3 }} />
                <Typography variant="body1">Copy Link</Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                onClick={handleWhatsAppShare}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: 1,
                  padding: '16px 24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  cursor: 'pointer',
                  height: '100%',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                    borderColor: '#d8b035'
                  }
                }}
              >
                <WhatsAppIcon sx={{ color: '#25D366', fontSize: 28, marginRight: 3 }} />
                <Typography variant="body1">Share via WhatsApp</Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                onClick={handleFacebookShare}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: 1,
                  padding: '16px 24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  cursor: 'pointer',
                  height: '100%',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                    borderColor: '#d8b035'
                  }
                }}
              >
                <FacebookIcon sx={{ color: '#4267B2', fontSize: 28, marginRight: 3 }} />
                <Typography variant="body1">Share on Facebook</Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                onClick={handleEmailShare}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: 1,
                  padding: '16px 24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  cursor: 'pointer',
                  height: '100%',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                    borderColor: '#d8b035'
                  }
                }}
              >
                <EmailIcon sx={{ color: '#EA4335', fontSize: 28, marginRight: 3 }} />
                <Typography variant="body1">Share via Email</Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        message="Link copied to clipboard"
      />

      <Toast open={toastOpen} severity={severity} message={toastMessage} onClose={() => setToastOpen(false)} />
    </Grid2>
  );
}

export default Product;

export const ImageWithFallback = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      width={"100%"}
      height={"400px"}
      onLoad={() => setLoaded(true)}
      style={{ display: loaded ? "block" : "none" }}
    />
  );
};
